import {
  CreateBookmarkDocument,
  CreateBookmarkListDocument,
  DeleteBookmarkDocument,
  DeleteBookmarkListDocument,
  StartJobDocument,
  UpdateBookmarkListDocument,
  UpdateJobDocument,
  ReviseReportDocument,
  GenerateDualPlusPublicSafetyReportDocument,
  ChangeJobOwnerDocument,
  JoinTeamByInvitationDocument,
  CopyJobDocument,
  CreateTeamDocument,
  InviteTeamMemberDocument,
  DeleteTeamMemberDocument,
  UpdateTeamInvitationDocument,
  DeleteTeamInvitationDocument,
  UpdateProfileDocument,
  GetProfilePictureUploadUrlDocument,
  AddSpeakerDocument,
  UpdateMomentDocument,
  DeleteMomentDocument,
  AddMomentDocument,
  UpdateSpeakerDocument,
  AddJobToTeamDocument,
  RemoveJobFromTeamDocument,
  ArchiveJobDocument,
  RetryJobDocument,
  UpdateTrackDocument,
  GetSpeakerPictureUploadUrlDocument,
  DeleteTrackDocument,
  GetAvatarUploadUrlDocument,
  GetCoverUploadUrlDocument,
  GetLogoUploadUrlDocument,
  UpdateTeamDocument,
  DeleteTeamDocument,
  UpdateTeamMemberRoleDocument,
  LeaveTeamDocument,
  UpgradeDocument,
  UpdateJobSourceDocument,
  MergeTracksDocument,
  AddTrackDocument,
  AddCommentDocument,
  AddReactionDocument,
  AddReplyDocument,
  EditCommentDocument,
  DeleteCommentDocument,
  ConnectExternalLibraryDocument,
  DeleteExternalLibraryDocument,
  GetJobThumbnailUploadUrlDocument,
  GetReportImageUploadUrlDocument,
  UpdateNotificationsSubscriptionDocument,
  DeleteNotificationsSubscriptionSubscribedEventDocument,
  StartLiveJobDocument,
  UpdateLiveJobSourceDocument,
  DuplicateTrackDocument,
  CreateNotificationsSubscriptionDocument,
  StopLiveJobDocument,
  ConfirmSpeakerPredictionDocument,
  UpdateTeamMemberDocument,
  ExportClipsDocument,
  CreateMultipartUploadDocument,
  GetGptAnswerDocument,
  CompleteMultipartUploadDocument,
  ExportTextEditorPdfDocument,
  SaveAgencySignupDraftDocument,
  ResumeAgencySignupDraftDocument,
  SubmitAgencySignupDocument,
  RequestAgencySampleReportUploadDocument,
  ConfirmAgencySampleReportUploadDocument,
  InviteAgencyLibraryDocument,
  InviteAllAgencyLibrariesDocument,
  UpdateAgencyOfficerDocument,
  AddAgencyOfficerDocument,
  UpdateAgencyDetailsDocument,
  AdminAddOfficerToAgencyDocument,
  AdminUpdateAgencyDetailsDocument,
  AdminUpdateAgencyOfficerDocument,
  AdminHardDeleteAgencyDocument,
  AdminSetDefaultJobSpecialityDocument,
  AdminSetJobTitleDocument,
  AdminSetOrgDefaultJobSpecialityDocument,
  AdminSyncAgencyLibrariesDocument,
  AdminUpdateAgencySettingsDocument,
  AdminUpdateAgencyVocabularyDocument,
  AdminUpdateAgencyReportDictionaryDocument,
  ExportJobAssetDocument,
  CreateAssetShareLinkDocument,
  CreateVideoShortLinkDocument,
  CreateMediaShortLinkDocument,
  RecordPlaybackSummaryDocument,
  AdminGrantAgencyOperatorDocument,
  AdminRenewAgencyOperatorDocument,
  AdminRevokeAgencyOperatorDocument,
  RequestAgencyOperatorRenewalDocument,
  AdminAssignLibraryToAgencyDocument,
  AdminRequestAgencyOperatorCertificateUploadDocument,
  AdminConfirmAgencyOperatorCertificateUploadDocument,
  UpdateAgencyFingerprintRequirementDocument,
  BeginAgencyPreviewDocument,
  EndAgencyPreviewDocument,
  ExportAuditEventsDocument,
} from '@clipr/lib';

import { print } from 'graphql';

export const ApiMutationDocuments = {
  createBookmarkList: CreateBookmarkListDocument,
  updateBookmarkList: UpdateBookmarkListDocument,
  deleteBookmarkList: DeleteBookmarkListDocument,
  createBookmark: CreateBookmarkDocument,
  deleteBookmark: DeleteBookmarkDocument,
  exportClips: ExportClipsDocument,

  startJob: StartJobDocument,
  updateJob: UpdateJobDocument,
  reviseReport: ReviseReportDocument,
  generateDualPlusPublicSafetyReport: GenerateDualPlusPublicSafetyReportDocument,
  changeJobOwner: ChangeJobOwnerDocument,
  copyJob: CopyJobDocument,
  getJobThumbnailUploadURL: GetJobThumbnailUploadUrlDocument,
  getReportImageUploadUrl: GetReportImageUploadUrlDocument,
  addMoment: AddMomentDocument,
  updateMoment: UpdateMomentDocument,
  deleteMoment: DeleteMomentDocument,
  addTrack: AddTrackDocument,
  updateTrack: UpdateTrackDocument,
  mergeTracks: MergeTracksDocument,
  duplicateTrack: DuplicateTrackDocument,

  startLiveJob: StartLiveJobDocument,
  stopLiveJob: StopLiveJobDocument,
  updateLiveJobSource: UpdateLiveJobSourceDocument,

  addSpeaker: AddSpeakerDocument,
  updateSpeaker: UpdateSpeakerDocument,
  getSpeakerPictureUploadUrl: GetSpeakerPictureUploadUrlDocument,
  confirmSpeakerPrediction: ConfirmSpeakerPredictionDocument,
  deleteTrack: DeleteTrackDocument,
  addJobToTeam: AddJobToTeamDocument,
  removeJobFromTeam: RemoveJobFromTeamDocument,
  archiveJob: ArchiveJobDocument,
  retryJob: RetryJobDocument,
  updateJobSource: UpdateJobSourceDocument,

  createTeam: CreateTeamDocument,
  deleteTeam: DeleteTeamDocument,
  updateTeam: UpdateTeamDocument,
  leaveTeam: LeaveTeamDocument,
  updateTeamMemberRole: UpdateTeamMemberRoleDocument,
  updateTeamMember: UpdateTeamMemberDocument,
  deleteTeamMember: DeleteTeamMemberDocument,
  inviteTeamMember: InviteTeamMemberDocument,
  getAvatarUploadUrl: GetAvatarUploadUrlDocument,
  getLogoUploadUrl: GetLogoUploadUrlDocument,
  getCoverUploadUrl: GetCoverUploadUrlDocument,
  joinTeamByInvitation: JoinTeamByInvitationDocument,
  updateTeamInvitation: UpdateTeamInvitationDocument,
  deleteTeamInvitation: DeleteTeamInvitationDocument,

  upgrade: UpgradeDocument,
  updateProfile: UpdateProfileDocument,
  getProfilePictureUploadUrl: GetProfilePictureUploadUrlDocument,

  createNotificationsSubscription: CreateNotificationsSubscriptionDocument,
  deleteNotificationsSubscriptionSubscribedEvent: DeleteNotificationsSubscriptionSubscribedEventDocument,
  updateNotificationsSubscription: UpdateNotificationsSubscriptionDocument,

  addComment: AddCommentDocument,
  addReaction: AddReactionDocument,
  addReply: AddReplyDocument,
  editComment: EditCommentDocument,
  deleteComment: DeleteCommentDocument,

  connectExternalLibrary: ConnectExternalLibraryDocument,
  deleteExternalLibrary: DeleteExternalLibraryDocument,

  getGPTAnswer: GetGptAnswerDocument,

  createMultipartUpload: CreateMultipartUploadDocument,
  completeMultipartUpload: CompleteMultipartUploadDocument,

  exportTextEditorPdf: ExportTextEditorPdfDocument,

  exportJobAsset: ExportJobAssetDocument,
  createAssetShareLink: CreateAssetShareLinkDocument,
  createVideoShortLink: CreateVideoShortLinkDocument,
  createMediaShortLink: CreateMediaShortLinkDocument,
  recordPlaybackSummary: RecordPlaybackSummaryDocument,

  saveAgencySignupDraft: SaveAgencySignupDraftDocument,
  resumeAgencySignupDraft: ResumeAgencySignupDraftDocument,
  submitAgencySignup: SubmitAgencySignupDocument,
  requestAgencySampleReportUpload: RequestAgencySampleReportUploadDocument,
  confirmAgencySampleReportUpload: ConfirmAgencySampleReportUploadDocument,
  inviteAgencyLibrary: InviteAgencyLibraryDocument,
  inviteAllAgencyLibraries: InviteAllAgencyLibrariesDocument,
  updateAgencyOfficer: UpdateAgencyOfficerDocument,
  addAgencyOfficer: AddAgencyOfficerDocument,
  updateAgencyDetails: UpdateAgencyDetailsDocument,
  adminAddOfficerToAgency: AdminAddOfficerToAgencyDocument,
  adminUpdateAgencyDetails: AdminUpdateAgencyDetailsDocument,
  adminUpdateAgencyOfficer: AdminUpdateAgencyOfficerDocument,
  adminHardDeleteAgency: AdminHardDeleteAgencyDocument,
  adminSetDefaultJobSpeciality: AdminSetDefaultJobSpecialityDocument,
  adminSetJobTitle: AdminSetJobTitleDocument,
  adminSetOrgDefaultJobSpeciality: AdminSetOrgDefaultJobSpecialityDocument,
  adminSyncAgencyLibraries: AdminSyncAgencyLibrariesDocument,
  adminUpdateAgencyVocabulary: AdminUpdateAgencyVocabularyDocument,
  adminUpdateAgencyReportDictionary: AdminUpdateAgencyReportDictionaryDocument,
  adminUpdateAgencySettings: AdminUpdateAgencySettingsDocument,
  adminGrantAgencyOperator: AdminGrantAgencyOperatorDocument,
  adminRenewAgencyOperator: AdminRenewAgencyOperatorDocument,
  adminRevokeAgencyOperator: AdminRevokeAgencyOperatorDocument,
  requestAgencyOperatorRenewal: RequestAgencyOperatorRenewalDocument,
  adminAssignLibraryToAgency: AdminAssignLibraryToAgencyDocument,
  adminRequestAgencyOperatorCertificateUpload: AdminRequestAgencyOperatorCertificateUploadDocument,
  adminConfirmAgencyOperatorCertificateUpload: AdminConfirmAgencyOperatorCertificateUploadDocument,
  updateAgencyFingerprintRequirement: UpdateAgencyFingerprintRequirementDocument,
  beginAgencyPreview: BeginAgencyPreviewDocument,
  endAgencyPreview: EndAgencyPreviewDocument,
  exportAuditEvents: ExportAuditEventsDocument,
} as const;

export const ApiMutations: { [key in keyof typeof ApiMutationDocuments]: string } = Object.fromEntries(
  Object.entries(ApiMutationDocuments).map(([name, doc]) => [name, print(doc)]),
) as { [key in keyof typeof ApiMutationDocuments]: string };
